<template>
  <div v-loading.fullscreen.lock="loading">
    <el-drawer
      size="95%"
      :visible="dialogDisplay"
      direction="btt"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :show-close="true"
      @close="closeModal">
      <div class="app-dialog-body">
        <h1 class="app-dialog-title">{{$t(title)}}</h1>
        <el-form :model="form" ref="formRef" :rules="formRules" label-position="left">
          <el-row>
            <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
              <el-form-item :label="$t('message.permission.roleName')" prop="roleName" label-width="150px">
                <el-input v-model="form.roleName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label-width="150px" :label="$t('message.permission.rolePermission')" prop="resourceIdStr" class="margin-bottom-0">
            <el-input type="hidden" v-model="form.resourceIdStr" />
          </el-form-item>
          <div class="tips margin-bottom-20">{{$t('message.permission.rolePermissionTip')}}</div>
          <el-tree
            ref="tree"
            :data="permissionList"
            :show-checkbox="true"
            default-expand-all
            :check-strictly="true"
            node-key="id"
            :default-checked-keys="resourceIdArr"
            :props="defaultProps"
            @check="checkChangeHandler">
          </el-tree>
          <el-row>
            <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
              <div class="align-right">
                <el-button @click="dialogDisplay = false">{{$t('message.tableCommon.cancel')}}</el-button>
                <el-button type="primary" @click="submit" :loading="isButtonLoading">{{$t('message.common.confirm')}}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getResourceList, saveRole, updateRole, getRolePermission } from '@/views/account/permission/api/role';
import {
  getParentNodes,
  getChildNodes,
  getParentNode,
  getChildrenNext,
  getValuesByKeyFromArrayObject,
} from '@/views/account/permission/role/edit/index';

export default {
  props: {
    title: { type: String, default: '' },
    edit: { type: Boolean, default: false },
    data: { type: Object, default: null },
  },
  data() {
    return {
      dialogDisplay: false,
      form: {
        roleName: '',
        resourceIdStr: '',
      },
      formRules: {
        roleName: [{ required: true, message: this.$t('message.validator.input', { input: this.$t('message.permission.roleName') }), trigger: 'blur' }],
        resourceIdStr: [{ required: true, message: ' ', trigger: 'blur' }],
      },
      resourceIdArr: [],
      permissionList: [],
      defaultProps: {
        children: 'childrenNode',
        label: 'name',
      },
      isButtonLoading: false,
      loading: false,
    };
  },
  methods: {
    async open() {
      // 首次打开时，加载资源树
      this.loading = true;
      if (!this.permissionList.length) {
        await getResourceList().then((res) => {
          this.permissionList = res;
        }).catch(() => ({}));
      }
      this.resetData();
      if (this.$props.edit) {
        this.form.roleName = this.$props.data.roleName;
        await getRolePermission(this.$props.data.id).then((res) => {
          this.resourceIdArr = getValuesByKeyFromArrayObject(res, 'resourceId');
          this.$refs.tree.setCheckedKeys(this.resourceIdArr);
        }).catch(() => ({}));
      } else {
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys(this.resourceIdArr);
        });
      }
      this.loading = false;
      this.$data.dialogDisplay = true;
    },
    parentIsChecked(newCheckedItems, parentId) {
      // 获取父节点
      const parentNode = getParentNode(this.permissionList, parentId);
      if (parentNode) {
        // 获取父节点下的所有子页面
        const nodes2 = getChildrenNext(parentNode);
        if (!nodes2.length) {
          return;
        }
        //  获取父节点下的所有子页面中被选中的子菜单
        const nodes2Checked = nodes2.filter((item) => newCheckedItems.includes(item));
        // 如果父节点下没有没有子节点被选中,父节点也不选中
        if (!nodes2Checked.length) {
          newCheckedItems.splice(newCheckedItems.indexOf(parentNode.id), 1);
          // 若还有父节点，需要继续遍历父节点是否需要取消
          this.parentIsChecked(newCheckedItems, parentNode.parentId);
        }
      }
    },
    checkChangeHandler(data) {
      const currentCheckedNodes = this.$refs.tree.getCheckedKeys();
      const checked = currentCheckedNodes.includes(data.id);
      if (checked) {
        // 子节点选中，父节点必定选中
        const parentNodes = getParentNodes(this.permissionList, data.id);
        const childrenNode = getChildNodes(this.permissionList, data.id);
        this.$refs.tree.setCheckedKeys(Array.from(new Set([...currentCheckedNodes, ...parentNodes, ...childrenNode])));
      } else {
        // 父节点不选中，子节点都取消选中
        const childrenNodes = getChildNodes(this.permissionList, data.id);
        const newCheckedItems = currentCheckedNodes.filter((item) => childrenNodes.indexOf(item) < 0);
        // 若父目录下没有一个子页面被选中，父目录也不选中
        if (data.resourceType === 1 && data.parentId !== '0') {
          this.parentIsChecked(newCheckedItems, data.parentId);
        }
        this.$refs.tree.setCheckedKeys(newCheckedItems);
      }
      this.resourceIdArr = this.$refs.tree.getCheckedKeys();
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.isButtonLoading = true;
          const roleData = {
            roleName: this.form.roleName.trim(),
            resourceId: this.resourceIdArr,
          };
          if (!this.$props.edit) {
            saveRole(roleData).then((res) => {
              this.dialogDisplay = false;
              this.$emit('onSuccess');
              this.isButtonLoading = false;
            }).catch(() => {
              this.isButtonLoading = false;
            });
            return;
          }
          // 编辑
          roleData.id = this.$props.data.id;
          updateRole(roleData).then(() => {
            this.dialogDisplay = false;
            this.$emit('onSuccess');
            this.isButtonLoading = false;
          }).catch(() => {
            this.isButtonLoading = false;
          });
        }
        if (!this.resourceIdArr.length) {
          this.$message.error(this.$t('message.validator.select', { select: this.$t('message.permission.permission') }));
        }
      });
    },
    resetData() {
      this.form.roleName = '';
      this.form.resourceIdStr = '';
      this.resourceIdArr = [];
    },
    closeModal() {
      this.dialogDisplay = false;
    },
  },
  watch: {
    resourceIdArr() {
      this.form.resourceIdStr = this.resourceIdArr.join(',');
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/variables.scss';

.tips {
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
  color: $color-text-primary;
  font-family: PingFangSC-Regular, PingFang SC;
}
.app-dialog-body {
  padding-bottom: 120px;
  box-sizing: inherit;
}
</style>
